'use client';

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';

import { cn } from 'lib/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // Square, line-strong border, ink fill on check. Lime is reserved for
      // CTAs and status — checkbox uses --text to track the existing pattern
      // (matches src/components/ui/radio.tsx).
      'peer h-4 w-4 shrink-0 border border-[var(--line-strong)] bg-[var(--input-bg)] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-[var(--ring-color)] disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-[var(--text)] data-[state=checked]:bg-[var(--text)] data-[state=checked]:text-[var(--bg)]',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      <Check className="h-3 w-3" strokeWidth={3} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
